import React from "react";
import ReactDOM from "react-dom";
import { StyledBackdrop } from "./StyledBackdrop";
import { CSSTransition } from "react-transition-group";


interface BackDropProps {
  backDrop?: any;
  onClick?: any;
  children: JSX.Element;
}

const Backdrop: React.FC<BackDropProps> = (props) => {
  const content = (
    <CSSTransition
      in={props.backDrop}
      timeout={200}
      classNames={{
        enterActive: "BackdropActive",
        enterDone: "BackdropEnterDone",
        exitActive: "BackdropExit",
        exitDone: "BackdropExitActive",
      }}
      mountOnEnter
      unmountOnExit
    >
      <StyledBackdrop onClick={props.onClick}>{props.children}</StyledBackdrop>
    </CSSTransition>
  );

  return ReactDOM.createPortal(
    content,
    document.getElementById("backdrop-hook")! as any
  );
};

export default Backdrop;
